@if (form && validationContext) {
  <rask-container-block [formGroup]="form">
    <div class="row">
      <rask-selector
        formControlName="pristyp"
        [rule]="validationContext.current.pristyp"
        [required]="true"
        class="col-2"
        [reverseLookup]="true"
        label="Pristyp"
        [values]="pristyper"
        aid="pristyp">
      </rask-selector>
      <rask-selector
        formControlName="volymlangdKategori"
        [required]="true"
        class="col-2"
        [rule]="validationContext.current.volymtyp"
        [reverseLookup]="true"
        label="Volymtyp"
        [values]="volymlangdkategorier"
        aid="volymlangdkategori">
      </rask-selector>
      <rask-selector
        formControlName="apteringsvillkor"
        [required]="true"
        class="col-2"
        [reverseLookup]="true"
        label="Apteringsvillkor"
        [rule]="validationContext.current.apteringsvillkor"
        [values]="apteringsvillkorLista"
        aid="apteringsvilkor">
      </rask-selector>
      <rask-multi-selector
        formControlName="tillatnaKvaliteter"
        class="col-2"
        label="Kvaliteter"
        [items]="tillatenKvalitetsList"
        [viewFormatter]="tillatenKvalitetsViewFormatter"
        [formatter]="tillatenKvalitetsSelectedFormatter"
        [viewSelectedFormatter]="tillatenKvalitetsViewFormatter"
        aid="tillatenkvalitet">
      </rask-multi-selector>
      <rask-checkbox class="col-1"
        text="Frikap"
        formControlName="manuellaKap">
      </rask-checkbox>
      <rask-checkbox class="col-2"
        text="Mindia-sök"
        formControlName="mindiameterSok">
      </rask-checkbox>
    </div>
    <div class="row">
      <div class="col-xl-3 col-s-12 col-lg-4 col-m-6 ps-0">
        <rask-label class="produktionstruktion-label" class="col-s-12 col-md-6" size="12">Tolerans vid kvalitetsgräns:</rask-label>
        <rask-input-number class="col-12 labelDistance" label="Topp" unit="cm" formControlName="kvalitetToleransTopp" [rule]="validationContext.current.kvalitetToleransTopp"></rask-input-number>
        <rask-input-number class="col-12" label="Rot" unit="cm" formControlName="kvalitetToleransRot" [rule]="validationContext.current.kvalitetToleransRot"></rask-input-number>
      </div>
      <div class="col-xl-3 col-s-12 col-lg-4 col-m-6 ps-0">
        <rask-label class="produktionstruktion-label" class="col-s-12 col-md-6" size="12">Diametergräns:</rask-label>
        <rask-input-number class="col-12 labelDistance" label="Min toppdiameter" unit="mm" formControlName="minstaToppdiameter" [rule]="validationContext.current.minstaToppdiameter"></rask-input-number>
        <rask-input-number class="col-12" label="Max rotdiameter" unit="mm" formControlName="maxRotdiameter" [rule]="validationContext.current.maxRotdiameter"></rask-input-number>
      </div>
      <div class="col-xl-3 col-s-12 col-lg-4 col-m-6 ps-0">
        <rask-label class="produktionstruktion-label" class="col-s-12 col-md-6" size="12">Kapfönster:</rask-label>
        <rask-input-number class="col-12 labelDistance" label="Nedre gräns" unit="cm" formControlName="kapfonsterNedreGrans" [rule]="validationContext.current.kapfonsterNedreGrans"></rask-input-number>
        <rask-input-number class="col-12" label="Övre gräns" unit="cm" formControlName="kapfonsterOvreGrans" [rule]="validationContext.current.kapfonsterOvreGrans"></rask-input-number>
      </div>
    </div>
  </rask-container-block>
}
